import axios from 'axios';
import { setupInterceptors } from './axiosInterceptor.js';
import { getTenantId, initializeTenant } from '../tenant/tenantService.js';

const PARTICIPANTS_URL = process.env.REACT_APP_PARTICIPANTS_URL;

const apiInternal = axios.create({ baseURL: PARTICIPANTS_URL });

const ensureTenantHeader = async (config) => {
  let tenantId = getTenantId();
  if (!tenantId) {
    try {
      await initializeTenant();
      tenantId = getTenantId();
    } catch (e) {
      console.error('Failed to initialize tenant:', e);
    }
  }
  if (tenantId) {
    config.headers = config.headers || {};
    config.headers['X-Tenant-Id'] = tenantId;
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
};

apiInternal.interceptors.request.use(ensureTenantHeader);
setupInterceptors(apiInternal);

const _pendingRequests = new Map();

const getInternalWalletBalances = async () => {
  const key = 'internal-wallets-balances';
  if (_pendingRequests.has(key)) return _pendingRequests.get(key);
  const promise = apiInternal
    .get('/api/internal-wallets/balances')
    .then(r => r.data)
    .finally(() => _pendingRequests.delete(key));
  _pendingRequests.set(key, promise);
  return promise;
};

const getAccountStatement = async (accountId, startDate, endDate) => {
  const key = `internal-wallets-statement-${accountId}-${startDate}-${endDate}`;
  if (_pendingRequests.has(key)) return _pendingRequests.get(key);
  const promise = apiInternal
    .get(`/api/internal-wallets/accounts/${accountId}/statement`, {
      params: { startDate, endDate },
    })
    .then(r => r.data)
    .finally(() => _pendingRequests.delete(key));
  _pendingRequests.set(key, promise);
  return promise;
};

export const internalWalletService = { getInternalWalletBalances, getAccountStatement };
